import About from "./components/About";
import Home from "./components/Home";
import Nav from "./components/Nav";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Boxes from "./components/Boxes";




function App() {
  
  return (
    <>
      <Nav/>
      
      <BrowserRouter>
        
          <Routes>
            
              <Route index element={<Boxes/>} />
              <Route path="boxes" element={<Boxes/>}></Route>
              <Route path="boat" element={<Home/>}></Route>
              <Route path="burger" element={<About/>}></Route>
              <Route path="puffer" element={<Projects/>}></Route>
              <Route path="carousel" element={<Contact/>}></Route>
              
          </Routes>
        
      </BrowserRouter>
      </>
  );
}

export default App;
